export const OnboardedStatus = {
  CREATED: 'CREATED',
  INVITED: 'INVITED',
  REGISTERED: 'REGISTERED',
  ONBOARDED: 'ONBOARDED',
};
